import {
  css,
  DSScaledColors,
  styled,
} from 'app/pages/request-single-page/components-v4/theme';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.s};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.s};
    border: 1px solid ${theme.colors.gray[100]};
    border-radius: ${theme.radiuses.s};
    box-shadow: ${theme.shadows.xs};
  `}
`;

export const IconWrapper = styled.div<{ $color: keyof DSScaledColors }>`
  ${({ theme, $color }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    aspect-ratio: 1 / 1;
    background-color: ${theme.colors[$color][100]};
    color: ${theme.colors[$color][500]};
    border-radius: ${theme.radiuses.xs};
  `}
`;
